// Configuración de Firebase con validaciones de seguridad
import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

// Tu configuración de Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyDWJFd_OzzJItHGSFfWcR619AyLaex3oOM',
  authDomain: 'contactos-3e98f.firebaseapp.com',
  projectId: 'contactos-3e98f',
  storageBucket: 'contactos-3e98f.firebasestorage.app',
  messagingSenderId: '467656078948',
  appId: '1:467656078948:web:38fdf7a8f794e6679e1171',
};

// Validar configuración de Firebase
const validateFirebaseConfig = (config) => {
  const requiredFields = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId',
  ];
  const missingFields = requiredFields.filter((field) => !config[field]);

  if (missingFields.length > 0) {
    throw new Error(
      `Configuración de Firebase incompleta. Campos faltantes: ${missingFields.join(', ')}`
    );
  }

  return true;
};

// Inicializar Firebase con validación
let app;
let db;

try {
  validateFirebaseConfig(firebaseConfig);
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);

  // Conectar al emulador solo en desarrollo
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_USE_FIRESTORE_EMULATOR === 'true'
  ) {
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('🔧 Conectado al emulador de Firestore para desarrollo');
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('✅ Firebase configurado correctamente');
  }
} catch (error) {
  console.error('❌ Error al configurar Firebase:', error);
  throw error;
}

export { db, app };
